var _path, _path2, _rect, _rect2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockDetailed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5019 14.9736C23.5019 21.1874 18.4647 26.2246 12.251 26.2246C6.03723 26.2246 1 21.1874 1 14.9736C1 8.75988 6.03723 3.72266 12.251 3.72266C18.4647 3.72266 23.5019 8.75988 23.5019 14.9736Z",
    fill: "white",
    stroke: "#717070",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7969 8.62109V15.4272H17.2417",
    stroke: "#717070",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.16797,
    width: 7.25983,
    height: 1.81496,
    rx: 0.907479,
    fill: "#747272"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 1.99023,
    width: 5.62998,
    height: 2.62,
    rx: 1,
    transform: "rotate(44.6947 21 1.99023)",
    fill: "#747272"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7969 0.907715V3.63015",
    stroke: "#747272",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockDetailed);
export default __webpack_public_path__ + "static/media/clock-detailed.43dd8327b2a48a8bcccc963f611a8dd5.svg";
export { ForwardRef as ReactComponent };